import { useState } from "react";

import { useAcademiYearContext } from "hooks/useAcademicYearContext";
import { useAuthContext } from "hooks/useAuthContext";
import { API_URL } from "../../config";

export const useAddAcademicYear = () => {
  const { user } = useAuthContext();
  const { programmes, dispatch } = useAcademiYearContext();

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const addacademicyear = async (academicyear) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_URL}/academicyears/createyear`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
        body: JSON.stringify({
          year: academicyear,
        }),
      });

      if (!response.ok) {
        const json = await response.json();
        throw new Error(json.error);
      }

      const json = await response.json();
      dispatch({ type: "ADD_ACADEMICYEAR", payload: json });
      setSuccess("Academic Year created successfully");
    } catch (error) {
      setError(
        error.message || "An error occurred when creating Academic Year"
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { addacademicyear, isLoading, error, success, setError, setSuccess };
};
